import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Star } from "lucide-react";
import { HOTEL } from "@/data/site";

export const Footer = () => (
  <footer className="bg-[#111827] text-white/80">
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto py-14 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-2 max-w-sm">
        <div className="font-serif text-xl font-bold text-white">Hotel Vijayshree Inn</div>
        <div className="text-sm text-amber-300/90">{HOTEL.nameHindi}</div>
        <p className="mt-3 text-sm leading-relaxed text-white/60">
          Affordable, warm hospitality in the heart of Khamla, Nagpur — steps from Wardha Road and minutes from the airport.
        </p>
        <div className="mt-4 inline-flex items-center gap-2 text-sm">
          <Star className="h-4 w-4 fill-amber-400 text-amber-400" /> {HOTEL.rating} · {HOTEL.reviews} Google reviews
        </div>
      </div>

      <div>
        <h4 className="text-white font-semibold text-sm mb-3">Explore</h4>
        <ul className="space-y-2 text-sm">
          {["rooms", "amenities", "gallery", "location", "reviews"].map((id) => (
            <li key={id}>
              <button onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })}
                className="hover:text-amber-300 capitalize transition-colors">{id}</button>
            </li>
          ))}
          <li><Link to="/admin" className="hover:text-amber-300 transition-colors">Admin Portal</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-semibold text-sm mb-3">Contact</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start gap-2"><MapPin className="h-4 w-4 shrink-0 mt-0.5 text-amber-300" /> <span>{HOTEL.address}</span></li>
          <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-amber-300" /> <a href={`tel:${HOTEL.phoneRaw}`} className="hover:text-amber-300">{HOTEL.phone}</a></li>
          <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-amber-300" /> <a href={`mailto:${HOTEL.email}`} className="hover:text-amber-300">{HOTEL.email}</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
      © {new Date().getFullYear()} Hotel Vijayshree Inn, Khamla, Nagpur. All rights reserved.
    </div>
  </footer>
);
